import React from 'react'
import classNames from 'classnames'
import './styles.scss'
import { IModalContentProps } from './interface'

const baseClass = 'modal-content'

const ModalContent: React.FC<IModalContentProps> = ({ children, className, ...rest }) => (
  <div className={classNames(baseClass, { [className]: className })} {...rest}>
    {children}
  </div>
)

export default ModalContent
